import { useEffect, useState } from "react";
import { getAutorizacoesConfig, getRestricoesConfig } from "../services/autorizacao.service";

export function useAutorizacoes(tipoEstabelecimento) {
  const [options, setOptions] = useState([]);
  const [restricoes, setRestricoes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      try {
        const options = await getAutorizacoesConfig(tipoEstabelecimento);
        const restricoes = await getRestricoesConfig();
        setOptions(options?.tipoAutorizacoes || []);
        setRestricoes(restricoes?.restricaoAutorizacoes || []);
      } catch {
        setOptions([]);
        setRestricoes([]);
      } finally {
        setLoading(false);
      }
    }

    if (tipoEstabelecimento) load();
  }, [tipoEstabelecimento]);

  return { options, loading, restricoes };
}
